import React, { useCallback, useContext, useEffect, useState } from 'react';

import OverlayNetworksTable from '@totem/components/services/remoteAccess/overlayNetworks/OverlayNetworksTable';
import { RemoteAccessOverlayNetwork } from '@totem/components/ticketing/remoteAccess';
import Loading from '@totem/components/ui_components/specialCases/Loading';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { REMOTE_ACCESS_ENDPOINT } from '@totem/utilities/endpoints';
import { CheckResponseShowError } from '@totem/utilities/responseUtilities';

const OverlayNetworksContainer = () => {
  const { getApiToken } = useContext(UserProfileContext);
  const [isSending, setIsSending] = useState(false);
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [overlaysLoaded, setOverlaysLoaded] = useState(false);
  const [overlayNetworks, setOverlayNetworks] = useState<
    RemoteAccessOverlayNetwork[]
  >([]);

  useEffect(() => {
    if (!refreshData) {
      return;
    }
    setRefreshData(false);

    fetch(`${REMOTE_ACCESS_ENDPOINT}/overlayNetworks/onDemand`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: RemoteAccessOverlayNetwork[]) => {
        setOverlayNetworks(result);

        setOverlaysLoaded(true);
      });
  }, [getApiToken, refreshData]);

  const sendToggleOverlayNetworkEnabled = useCallback(
    async (selectedRecord: RemoteAccessOverlayNetwork, enable: boolean) => {
      if (isSending) {
        return;
      }
      setIsSending(true);

      const payload = {
        enabled: enable,
      };

      fetch(
        `${REMOTE_ACCESS_ENDPOINT}/overlayNetworks/onDemand/${selectedRecord.overlayNetwork.id}`,
        {
          method: 'PATCH',
          headers: new Headers({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getApiToken()}`,
          }),
          body: JSON.stringify(payload),
        },
      )
        .then((res) => {
          const success = CheckResponseShowError(res);
          if (success) {
            setRefreshData(true);
          }
        })
        .then(() => {
          setIsSending(false);
        });
    },
    [isSending],
  );

  const handleToggleOverlayNetowrkEnabled = (
    overlay: RemoteAccessOverlayNetwork,
    enabled: boolean,
  ) => {
    sendToggleOverlayNetworkEnabled(overlay, enabled);
  };

  if (!overlaysLoaded) {
    return <Loading />;
  }

  return (
    <OverlayNetworksTable
      overlayNetworks={overlayNetworks}
      toggleEnabled={handleToggleOverlayNetowrkEnabled}
    />
  );
};

export default OverlayNetworksContainer;
